let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1pzf9")).then(() => parcelRequire('cIoVd'));